module.exports = __webpack_public_path__ + "img/media_2.90e2bb1b.jpg";